import * as core from '../../../../../../../core'
import * as stakeholderEngagementNeeded from '../stakeholder-engagement-needed'

export const RESOURCE = {
  payload: {
    description: 'Targeted Group Engagement',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderEngagementNeeded.RESOURCE.payload.partialId,
    }),
    id: 'Targeted Group Engagement',
    name: 'Targeted Group Engagement',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
